import { render, staticRenderFns } from "./editCardReader.vue?vue&type=template&id=5c321c92&scoped=true&"
import script from "./editCardReader.vue?vue&type=script&lang=js&"
export * from "./editCardReader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c321c92",
  null
  
)

export default component.exports